__webpack_require__.p = "/react-typescript-chess/";